@if(_user){
<div
  class="tw-inline-flex tw-gap-1 tw-px-2 tw-py-1 surface-opacity-darker hover:surface-opacity tw-rounded-md tw-items-center">
  <div
    class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-aspect-square tw-rounded-full tw-bg-contain tw-bg-center"
    [ngClass]="{'surface-secondary': !_user.profile?.['picture']}"
    [ngStyle]="{'background-image': _user.profile?.['picture'] ? 'url(' + _user.profile?.['picture'] + ')' : undefined}">
    @if(!(_user.profile?.['picture'])){ {{initials}} }
  </div>
  <div class="tw-flex tw-flex-col tw-whitespace-nowrap">
    <span class="tg-label tw-max-w-52 tw-overflow-hidden tw-overflow-ellipsis" [title]="name">{{name}}</span>
    <span class="tg-sm text-muted">
      <div class="tw-flex tw-items-center tw-max-w-52 tw-overflow-hidden tw-overflow-ellipsis tw-gap-1 tw-cursor-copy"
        [cdkCopyToClipboard]="_user.email" [title]="_user.email">
        @if(_user.isEmailVerified) {
        <mat-icon class="!text-success" [inline]="true" matTooltip="Email Verified">check_circle</mat-icon>
        }
        {{_user.email}}
      </div>
    </span>
  </div>
</div>
} @else if(_agent){
<div class="tw-flex tw-gap-2 tw-items-center">
  <div
    class="tw-flex tw-items-center tw-justify-center tw-w-10 tw-aspect-square tw-rounded-full  tw-bg-contain tw-bg-center surface-secondary">
    {{initials}}
  </div>
  <div class="tw-flex tw-flex-col tw-whitespace-nowrap">
    <span>{{name}}</span>
    <span class="tg-sm text-muted">{{_agent.agentInfo.liveTransfer?.phone}}
      <!-- @if(_agent.availability){ [×{{_agent.availability}}] } -->
    </span>
  </div>
  @if(!_agent.agentInfo.liveTransfer?.available){<i class="pi pi-ban tw-text-red-500" title="Not Available"></i>}
</div>
}